import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { collectErrorMessages } from "../utils/formErrorUtils";
export var useFieldArrayErrors = function (fieldName) {
    var formatMessage = useIntl().formatMessage;
    var errors = useFormContext().formState.errors;
    var fieldErrors = errors[fieldName];
    return useMemo(function () {
        var _a;
        if (!fieldErrors)
            return [];
        var messages = [];
        // Whole-array (root) validation message, e.g. an object-level superRefine
        // rule such as "a title must have exactly one main title name". Such an
        // error is attached to the array field itself, not to an individual row.
        var asRecord = fieldErrors;
        var rootMessage = typeof asRecord.message === "string"
            ? asRecord.message
            : typeof ((_a = asRecord.root) === null || _a === void 0 ? void 0 : _a.message) === "string"
                ? asRecord.root.message
                : null;
        if (rootMessage)
            messages.push(rootMessage);
        if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(function (err, i) {
                if (!err)
                    return;
                var rowMessages = collectErrorMessages(err);
                if (!rowMessages.length)
                    return;
                messages.push("".concat(formatMessage({ id: "ui-br-agency.title.form.row" }, { index: i + 1 }), ": ").concat(rowMessages.join(", ")));
            });
        }
        return messages;
    }, [fieldErrors, formatMessage]);
};
